import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import "../Usuario/UsuarioUp.scss";
import Swal from "sweetalert2";
function UsuarioEdit() {
  const { id } = useParams();
  const [notificacoesPredefinidass, setNotificacoessPredefinidas] = useState([]);
  const [notificacoesSelecionadass, setNotificacoessSelecionadas] = useState([]);
  const [notificacoesPredefinidassCopy, setNotificacoessPredefinidasCopy] = useState([]);
  const [notificacoesSelecionadassCopy, setNotificacoessSelecionadasCopy] = useState([]);
  const [backupGruposDisponiveis, setBackupGruposDisponiveis] = useState([]);
  const [backupGruposSelecionados, setBackupGruposSelecionados] = useState([]);
  const [backupNotificacoesDisponiveis, setBackupNotificacoesDisponiveis] = useState([]);
  const [backupNotificacoesSelecionadas, setBackupNotificacoesSelecionadas] = useState([]);
  const [notificacoesPredefinidas, setNotificacoesPredefinidas] = useState([]);
  const [notificacoesSelecionadas, setNotificacoesSelecionadas] = useState([]);
  const [notificacoesPredefinidasCopy, setNotificacoesPredefinidasCopy] = useState([]);
  const [notificacoesSelecionadasCopy, setNotificacoesSelecionadasCopy] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [referencias, setReferencias] = useState([]);
  const [valorTipoNotifi, setValorTipoNotifi] = useState("");
  const [habilitarNotificacao, setHabilitarNotificacao] = useState("");
  const [toogleAll, setToogleAll] = useState("");
  const [values, setValues] = useState({});
  const [search, setSearch] = useState("");
  const [searchs, setSearchs] = useState("");
  const [marcadores, setMarcadores] = useState([]);
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [senhaError, setSenhaError] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false);
  const navigate = useNavigate();
  const [veiculos, setVeiculos] = useState([]);
  const [veiculosSelecionados, setVeiculosSelecionados] = useState([]);
  const [gruposPredefinidos, setGruposPredefinidos] = useState([]);
  const [gruposSelecionadas, setGruposSelecionadas] = useState([]);
  const [tipoPermissao, setTipoPermissao] = useState("");
  const [confirmacaoFeita, setConfirmacaoFeita] = useState(false);
  const [confirmacaoRemocaoFeita, setConfirmacaoRemocaoFeita] = useState(false);
  const [usuarioOriginal, setUsuarioOriginal] = useState({});
  const [userError, setUserError] = useState("");
  const [verificandoUser, setVerificandoUser] = useState(false);
  const [userDisponivel, setUserDisponivel] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [emailDisponivel, setEmailDisponivel] = useState(false);
  const [verificandoEmail, setVerificandoEmail] = useState(false);
  const [emailVerificado, setEmailVerificado] = useState(false);
  const [codigoEnviado, setCodigoEnviado] = useState(false);




  // -------------------------------------------------------------------------


  // =============================
  // MOVER PARA SELECIONADOS
  // =============================
  const moverParaSelecionados = async (veiculo) => {
    const jaExiste = veiculosSelecionados.some(v => v.placa === veiculo.placa);

    if (jaExiste) {
      Swal.fire({
        icon: "warning",
        title: "Veículo já adicionado",
        text: "Este equipamento/veículo já está na lista.",
      });
      return;
    }

    //  Se ainda não confirmou, pergunta
    if (!confirmacaoFeita) {
      const result = await Swal.fire({
        title: "Confirmar ação?",

        background: "#111827",
        color: "#f9fafb",

        width: 560,

        html: `
    <div style="
      margin-top:16px;

      padding:16px;

      border-radius:12px;

      background:#0f172a;

      border:1px solid rgba(255,255,255,0.06);

      text-align:left;

      line-height:1.8;
    ">

      <div style="
        color:#d1d5db;

        font-size:14px;

        margin-bottom:14px;
      ">
        Você está prestes a adicionar equipamentos/veículos.
      </div>

      <div style="
        padding:10px 12px;

        border-radius:8px;

        background:rgba(239,68,68,0.08);

        border:1px solid rgba(239,68,68,0.18);

        color:#fca5a5;

        font-size:13px;
      ">
        Após confirmar, a operação não poderá ser desfeita.
      </div>

    </div>
  `,

        icon: "warning",

        showCancelButton: true,

        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",

        confirmButtonColor: "#2563eb",
        cancelButtonColor: "#1f2937",

        reverseButtons: true,

        allowOutsideClick: false,
        allowEscapeKey: false,

        customClass: {
          popup: "rounded-4",
        },
      });
      if (!result.isConfirmed) return;

      setConfirmacaoFeita(true); //  nunca mais pergunta
    }

    setVeiculosSelecionados(prev => [...prev, veiculo]);
  };



  // =============================
  // REMOVER DE SELECIONADOS
  // =============================
  const moverParaDisponiveis = async (veiculo) => {

    //  Se ainda não confirmou remoção
    if (!confirmacaoRemocaoFeita) {
      const result = await Swal.fire({
        title: "Remover item?",

        background: "#111827",
        color: "#f9fafb",

        width: 560,

        html: `
    <div style="
      margin-top:14px;

      padding:16px;

      border-radius:12px;

      background:#0f172a;

      border:1px solid rgba(255,255,255,0.06);

      text-align:left;
    ">

      <div style="
        color:#d1d5db;

        font-size:14px;

        line-height:1.7;

        margin-bottom:14px;
      ">
        Você está prestes a remover um equipamento/veículo.
      </div>

      <div style="
        padding:10px 12px;

        border-radius:8px;

        background:rgba(239,68,68,0.08);

        border:1px solid rgba(239,68,68,0.15);

        color:#fca5a5;

        font-size:13px;

        line-height:1.6;
      ">
        Esta ação não poderá ser revertida após a confirmação.
      </div>

    </div>
  `,

        icon: "warning",

        showCancelButton: true,

        confirmButtonText: "Remover",
        cancelButtonText: "Cancelar",

        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#1f2937",

        reverseButtons: true,

        allowOutsideClick: false,
        allowEscapeKey: false,

        customClass: {
          popup: "rounded-4",
        },
      });

      if (!result.isConfirmed) return;

      setConfirmacaoRemocaoFeita(true); //  nunca mais pergunta
    }

    setVeiculosSelecionados(prev =>
      prev.filter(v => v.placa !== veiculo.placa)
    );
  };













  const handleSelecionadas = (valor) => {
    const update = [...notificacoesSelecionadas, valor];
    setNotificacoesSelecionadas(update);
    setNotificacoesSelecionadasCopy(update);
    const update2 = [...notificacoesPredefinidas];
    update2.splice(notificacoesPredefinidas.indexOf(valor), 1);
    setNotificacoesPredefinidas(update2);
    setNotificacoesPredefinidasCopy(update2);
  };




  useEffect(() => {
    if (confirmarSenha && senha !== confirmarSenha) {
      setSenhaError("As senhas não coincidem");
    } else {
      setSenhaError("");
    }
  }, [senha, confirmarSenha]);

  const handlePredefinidas = (valor) => {
    const update = [...notificacoesPredefinidas, valor];
    setNotificacoesPredefinidas(update);
    setNotificacoesPredefinidasCopy(update);
    const update2 = [...notificacoesSelecionadas];
    update2.splice(notificacoesSelecionadas.indexOf(valor), 1);
    setNotificacoesSelecionadas(update2);
    setNotificacoesSelecionadasCopy(update2);
  };
  // -------------------------------------------------------------------------
  const handleSelecionadass = (grupo) => {
    setNotificacoessSelecionadas((prev) => [...prev, grupo]);
    setNotificacoessPredefinidas((prev) => prev.filter((g) => g.id !== grupo.id));
  };

  const handlePredefinidass = (grupo) => {
    setNotificacoessPredefinidas((prev) => [...prev, grupo]);
    setNotificacoessSelecionadas((prev) => prev.filter((g) => g.id !== grupo.id));
  };

  // -------------------------------------------------------------------------
  useEffect(() => {
    async function fetchGrupos() {
      try {
        //  Buscar todos grupos
        const { data: todosGrupos } = await api.get("/grupos1", {
          headers: {
            typo: localStorage.getItem("id"),
            inova: localStorage.getItem("inova"),
          },
        });

        //  Grupos que já estão vinculados ao usuário
        const gruposSelecionadosUsuario = todosGrupos.filter(g =>
          (grupos || []).includes(g.id)
        );

        //  Grupos disponíveis
        const gruposDisponiveisUsuario = todosGrupos.filter(g =>
          !(grupos || []).includes(g.id)
        );

        //  Setar estados
        setGruposSelecionadas(gruposSelecionadosUsuario);
        setGruposPredefinidos(gruposDisponiveisUsuario);

        setGrupos(todosGrupos);
      } catch (error) { }
    }
    fetchGrupos();
  }, []);




  useEffect(() => {
    async function fetchReferencias() {
      const { data } = await api.get("/referencias", {
        headers: {
          typo: localStorage.getItem("id"),
          inova: localStorage.getItem("inova"),
        },
      });
      setReferencias(data);
    }
    fetchReferencias();
  }, []);



  useEffect(() => {
    async function fetchById() {

      const { data } = await api.get(`/usuarios/${id}`, {
        headers: {
          typo: localStorage.getItem("id"),
          inova: localStorage.getItem("inova"),
        },
      });

      //  salva estado original COMPLETO
      setUsuarioOriginal(JSON.parse(JSON.stringify(data)));

      const { veiculos, nome, email, user, grupos, tipo, obs } = data;

      // ================================
      // VEÍCULOS
      // ================================

      const placasSelecionadas = veiculos
        ? veiculos
          .replace(/'/g, "")
          .split(",")
          .map(p => p.trim())
          .filter(p => p !== "")
        : [];

      const { data: todosVeiculos } = await api.get("/equipamentos", {
        headers: {
          typo: localStorage.getItem("id"),
          inova: localStorage.getItem("inova"),
        },
      });

      const veiculosUnicos = [
        ...new Map(todosVeiculos.map(v => [v.placa, v])).values()
      ];

      const veiculosSelecionadosUsuario = veiculosUnicos.filter(v =>
        placasSelecionadas.includes(v.placa)
      );

      const veiculosDisponiveisUsuario = veiculosUnicos.filter(v =>
        !placasSelecionadas.includes(v.placa)
      );

      setVeiculos(veiculosDisponiveisUsuario);
      setVeiculosSelecionados(veiculosSelecionadosUsuario);

      // ================================
      // GRUPOS
      // ================================

      const gruposIds = Array.isArray(grupos)
        ? grupos.map(Number)
        : typeof grupos === "string"
          ? grupos.replace(/'/g, "")
            .split(",")
            .map(g => parseInt(g.trim()))
            .filter(g => !isNaN(g))
          : [];

      const { data: todosGrupos } = await api.get("/grupos1", {
        headers: {
          typo: localStorage.getItem("id"),
          inova: localStorage.getItem("inova"),
        },
      });

      const gruposSelecionadosUsuario = todosGrupos.filter(g =>
        gruposIds.includes(g.id)
      );

      const gruposDisponiveisUsuario = todosGrupos.filter(g =>
        !gruposIds.includes(g.id)
      );

      setGruposSelecionadas(gruposSelecionadosUsuario);
      setGruposPredefinidos(gruposDisponiveisUsuario);

      // ================================
      // DADOS PRINCIPAIS
      // ================================

      setValues({
        nome,
        email,
        user,
        tipo,
        obs,
      });

      setTipoPermissao(tipo);
    }

    fetchById();
  }, [id]);




  //SELECIONAR TODOS OS EQUIPAMENTOS
  const handleAll = async (e) => {

    const checked = e.target.checked;

    if (checked) {

      const result = await Swal.fire({
        title: "⚠️ Confirmação necessária",
        html: `
        <p style="font-size:15px">
          Você está prestes a adicionar <strong>TODOS</strong> os equipamentos/veículos disponíveis.
        </p>
        <p style="color:#d33; font-weight:600; margin-top:10px">
          Esta ação impactará toda a lista atual.
        </p>
      `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, adicionar todos",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        allowOutsideClick: false,
        allowEscapeKey: false
      });

      if (!result.isConfirmed) {
        e.target.checked = false; //  reverte visualmente
        return;
      }

      // 🔹 Sua lógica original
      setBackupNotificacoesDisponiveis([...veiculos]);
      setBackupNotificacoesSelecionadas([...veiculosSelecionados]);

      setVeiculosSelecionados([
        ...veiculosSelecionados,
        ...veiculos
      ]);

      setVeiculos([]);

      Swal.fire({
        icon: "success",
        title: "Operação concluída",
        text: "Todos os equipamentos/veículos foram adicionados.",
        timer: 1500,
        showConfirmButton: false
      });

    } else {

      const result = await Swal.fire({
        title: "Restaurar estado anterior?",
        text: "Os equipamentos/veículos retornarão à lista original.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim, restaurar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#3085d6"
      });

      if (!result.isConfirmed) {
        e.target.checked = true; // mantém marcado
        return;
      }


      setVeiculos([...backupNotificacoesDisponiveis]);
      setVeiculosSelecionados([...backupNotificacoesSelecionadas]);
    }
  };





  // =============================
  // GRUPOS DISPONÍVEIS
  // =============================
  const gruposDisponiveis = gruposPredefinidos.filter(
    g => !gruposSelecionadas.some(sel => sel.id === g.id)
  );
  // FILTRO GRUPOS
  const gruposFiltrados = gruposDisponiveis.filter((g) =>
    (g.nome || "").toLowerCase().includes(searchs.toLowerCase())
  );


  const moverGrupoParaSelecionados = (grupo) => {
    setGruposSelecionadas(prev => {
      if (prev.some(g => g.id === grupo.id)) return prev;
      return [...prev, grupo];
    });
  };

  const moverGrupoParaDisponiveis = (grupo) => {
    setGruposSelecionadas(prev =>
      prev.filter(g => g.id !== grupo.id)
    );
  };









  //=============================
  //FILTRO EQUIPAMENTOS/VEICULOS
  //=============================

  // 1️   primeiro calcula disponíveis
  const veiculosDisponiveis = veiculos.filter(
    v => !veiculosSelecionados.some(sel => sel.placa === v.placa)
  );

  // 2 depois aplica o search
  const filterPlaca = veiculosDisponiveis.filter((v) =>
    (v.placa || "").toLowerCase().includes(search.toLowerCase()) ||
    (v.nome || "").toLowerCase().includes(search.toLowerCase())
  );

  console.log("Search:", search);
  console.log("Filtrados:", filterPlaca);




  //SELECIONAR TODOS OS GRUPOS
  const handleAllGrupos = async (e) => {
    const checked = e.target.checked;

    if (checked) {

      const result = await Swal.fire({
        title: "⚠️ Confirmação necessária",
        html: `
        <p>Você está prestes a adicionar <strong>TODOS</strong> os grupos.</p>
        <p style="color:#d33; font-weight:600;">
          Esta ação modificará completamente a seleção atual.
        </p>
      `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, adicionar todos",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#d33",
        allowOutsideClick: false,
        allowEscapeKey: false
      });

      if (!result.isConfirmed) {
        e.target.checked = false; // 🔥 desfaz visualmente
        return;
      }

      // 🔹 Mantém SUA lógica original
      setBackupGruposDisponiveis(gruposPredefinidos);
      setBackupGruposSelecionados(gruposSelecionadas);

      setGruposSelecionadas([
        ...gruposSelecionadas,
        ...gruposPredefinidos
      ]);

      setGruposPredefinidos([]);

    } else {

      const result = await Swal.fire({
        title: "Restaurar estado anterior?",
        text: "Os grupos voltarão exatamente como estavam antes.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim, restaurar",
        cancelButtonText: "Cancelar"
      });

      if (!result.isConfirmed) {
        e.target.checked = true; // 🔥 mantém marcado
        return;
      }

      // 🔹 Mantém SUA lógica original
      setGruposPredefinidos(backupGruposDisponiveis);
      setGruposSelecionadas(backupGruposSelecionados);
    }
  };



  const filterPlacas = notificacoesPredefinidass.filter((grupo) => grupo.nome.toLowerCase().includes(searchs.toLowerCase()));

  const handleChange = (event) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
      cliente: localStorage.getItem("id"),
    }));

    // ==========================================
    // VALIDAÇÃO DO USUÁRIO
    // ==========================================
    if (name === "user") {
      setUserError("");
      setUserDisponivel(false);

      if (name === "email") {
        verificarEmail(value);
      }



      const userOriginal = usuarioOriginal?.user
        ?.trim()
        .toLowerCase();

      const userAtual = value.trim().toLowerCase();

      // Se voltou para o usuário original
      if (userAtual === userOriginal) {
        setUserDisponivel(true);
        return;
      }

      // Só consulta se tiver algum valor
      if (userAtual) {
        verificarUser(userAtual);
      }
    }
  };



  // ==========================================
  // VERIFICAR NOME DE USUÁRIO
  // ==========================================
  const verificarUser = async (userInformado) => {
    const user = userInformado?.trim().toLowerCase();

    if (!user) {
      setUserError("");
      setUserDisponivel(false);
      return;
    }

    // Se não mudou o usuário original, não precisa consultar
    const userOriginal = usuarioOriginal?.user?.trim().toLowerCase();

    if (user === userOriginal) {
      setUserError("");
      setUserDisponivel(true);
      return;
    }

    try {
      setVerificandoUser(true);
      setUserError("");
      setUserDisponivel(false);

      const response = await api.post("/usuarios/verificar", {
        id,
        user,
      });

      if (response.status === 200) {
        setUserError("");
        setUserDisponivel(true);
      }

    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.campo === "user"
      ) {
        setUserError(error.response.data.mensagem);
        setUserDisponivel(false);
        return;
      }

      setUserError("Não foi possível verificar o nome de usuário.");
      setUserDisponivel(false);

    } finally {
      setVerificandoUser(false);
    }
  };



  // ==========================================
  // VERIFICAR E-MAIL
  // ==========================================

  const verificarEmail = async (emailInformado) => {
    const email = emailInformado.trim();

    // Campo vazio = e-mail opcional
    if (!email) {
      setEmailError("");
      setEmailDisponivel(false);
      setVerificandoEmail(false);
      return;
    }

    // Ainda não parece um e-mail válido
    const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!emailValido) {
      setEmailError("");
      setEmailDisponivel(false);
      return;
    }

    try {
      setVerificandoEmail(true);
      setEmailError("");
      setEmailDisponivel(false);

      const response = await api.post("/usuarios/verificar", {
        email,
      });

      // E-mail disponível
      setEmailError("");
      setEmailDisponivel(true);

    } catch (error) {

      if (
        error.response &&
        error.response.data.campo === "email"
      ) {
        setEmailError(
          error.response.data.mensagem
        );

        setEmailDisponivel(false);
        return;
      }

      setEmailError("Não foi possível verificar o e-mail.");
      setEmailDisponivel(false);

    } finally {
      setVerificandoEmail(false);
    }
  };








  //==============================
  // EDITAR DADOS USUARIO CADASTRO
  //==============================
  const handleSubmit = async () => {
    try {

      // ==========================================
      // VALIDAR NOME DE USUÁRIO
      // ==========================================

      const userAtual = values.user?.trim().toLowerCase();
      const userOriginal = usuarioOriginal?.user?.trim().toLowerCase();

      // Usuário obrigatório
      if (!userAtual) {
        setUserError("Informe um nome de usuário.");
        setUserDisponivel(false);

        toast.error("Informe um nome de usuário.");
        return;
      }

      // Se não alterou o usuário original,
      // não precisa consultar o banco
      if (userAtual === userOriginal) {
        setUserError("");
        setUserDisponivel(true);
      } else {

        // Se alterou o usuário, precisa verificar
        if (!userDisponivel) {

          await verificarUser(userAtual);

          toast.error(
            "Verifique a disponibilidade do nome de usuário."
          );

          return;
        }
      }

      // ==========================================
      // PAYLOAD
      // ==========================================

      const payload = {
        ...values,
        veiculos: veiculosSelecionados.map(v => v.placa),
        grupos: gruposSelecionadas.map(g => g.id),
        cliente: localStorage.getItem("id"),
        editado_por: localStorage.getItem("clientID"),
      };

      const alteracoes = [];

      // =========================
      // CAMPOS SIMPLES
      // =========================

      Object.keys(values).forEach((key) => {

        if (values[key] !== usuarioOriginal[key]) {

          // Nunca mostrar campos técnicos
          if (key === "cliente" || key === "editado_por") return;

          alteracoes.push({
            tipo: "campo",
            label: key.toUpperCase(),
            antes: usuarioOriginal[key] || "-",
            depois: values[key] || "-"
          });
        }

      });

      // =========================
      // VEÍCULOS
      // =========================

      const placasOriginais = usuarioOriginal.veiculos
        ? usuarioOriginal.veiculos
          .replace(/'/g, "")
          .split(",")
          .map(p => p.trim())
          .filter(p => p !== "")
        : [];

      const placasNovas = veiculosSelecionados.map(v => v.placa);

      if (
        JSON.stringify(placasOriginais.sort()) !==
        JSON.stringify(placasNovas.sort())
      ) {

        alteracoes.push({
          tipo: "lista",
          label: "VEÍCULOS",
          antes: placasOriginais,
          depois: placasNovas
        });

      }

      // =========================
      // GRUPOS
      // =========================

      const nomesGruposOriginais = usuarioOriginal.grupos
        ? gruposPredefinidos
          .concat(gruposSelecionadas)
          .filter(g => usuarioOriginal.grupos.includes(g.id))
          .map(g => g.nome)
        : [];

      const nomesGruposNovos = gruposSelecionadas.map(g => g.nome);

      if (
        JSON.stringify(nomesGruposOriginais.sort()) !==
        JSON.stringify(nomesGruposNovos.sort())
      ) {

        alteracoes.push({
          tipo: "lista",
          label: "GRUPOS",
          antes: nomesGruposOriginais,
          depois: nomesGruposNovos
        });

      }

      // =========================
      // SE NÃO HOUVE ALTERAÇÃO
      // =========================

      if (alteracoes.length === 0) {
        toast.info("Nenhuma alteração foi realizada.");
        return;
      }

      // =========================
      // GERAR HTML BONITO
      // =========================

      const gerarHtmlResumo = () => {

        return alteracoes.map(item => {

          // =========================
          // LISTAS
          // =========================

          if (item.tipo === "lista") {

            const antesVisivel = item.antes.slice(0, 3);
            const depoisVisivel = item.depois.slice(0, 3);

            const precisaExpandir =
              item.antes.length > 3 ||
              item.depois.length > 3;

            return `
            <div style="
              margin-bottom:16px;
              padding:14px;
              border-radius:10px;
              background:#111827;
              border:1px solid rgba(255,255,255,0.05);
            ">

              <div style="
                font-size:13px;
                font-weight:600;
                color:#f9fafb;
                margin-bottom:12px;
                letter-spacing:0.2px;
              ">
                ${item.label}
              </div>

              <div style="
                display:flex;
                flex-direction:column;
                gap:10px;
              ">

                <div>

                  <div style="
                    font-size:12px;
                    color:#94a3b8;
                    margin-bottom:4px;
                  ">
                    Antes
                  </div>

                  <div style="
                    color:#e5e7eb;
                    font-size:13px;
                    line-height:1.7;
                  ">
                    ${antesVisivel.join(", ") || "-"}
                  </div>

                </div>

                <div>

                  <div style="
                    font-size:12px;
                    color:#94a3b8;
                    margin-bottom:4px;
                  ">
                    Depois
                  </div>

                  <div style="
                    color:#60a5fa;
                    font-size:13px;
                    line-height:1.7;
                  ">
                    ${depoisVisivel.join(", ") || "-"}
                  </div>

                </div>

              </div>

              ${precisaExpandir
                ? `
                    <details style="margin-top:12px;">

                      <summary style="
                        cursor:pointer;
                        color:#60a5fa;
                        font-size:13px;
                        user-select:none;
                      ">
                        Ver completo
                      </summary>

                      <div style="
                        margin-top:10px;
                        padding-top:10px;
                        border-top:1px solid rgba(255,255,255,0.05);
                      ">

                        <div style="
                          color:#94a3b8;
                          font-size:12px;
                          margin-bottom:4px;
                        ">
                          Antes
                        </div>

                        <div style="
                          color:#e5e7eb;
                          font-size:13px;
                          line-height:1.7;
                          margin-bottom:10px;
                        ">
                          ${item.antes.join(", ") || "-"}
                        </div>

                        <div style="
                          color:#94a3b8;
                          font-size:12px;
                          margin-bottom:4px;
                        ">
                          Depois
                        </div>

                        <div style="
                          color:#60a5fa;
                          font-size:13px;
                          line-height:1.7;
                        ">
                          ${item.depois.join(", ") || "-"}
                        </div>

                      </div>

                    </details>
                  `
                : ""
              }

            </div>
          `;
          }

          // =========================
          // CAMPOS SIMPLES
          // =========================

          return `
          <div style="
            margin-bottom:16px;
            padding:14px;
            border-radius:10px;
            background:#111827;
            border:1px solid rgba(255,255,255,0.05);
          ">

            <div style="
              font-size:13px;
              font-weight:600;
              color:#f9fafb;
              margin-bottom:10px;
            ">
              ${item.label}
            </div>

            <div style="
              display:flex;
              align-items:center;
              gap:10px;
              flex-wrap:wrap;
              font-size:13px;
            ">

              <span style="
                color:#9ca3af;
              ">
                ${item.antes || "-"}
              </span>

              <span style="
                color:#4b5563;
              ">
                →
              </span>

              <span style="
                color:#60a5fa;
                font-weight:500;
              ">
                ${item.depois || "-"}
              </span>

            </div>

          </div>
        `;

        }).join("");

      };

      // =========================
      // MODAL PROFISSIONAL
      // =========================

      const result = await Swal.fire({

        title: "Confirmar alterações?",

        background: "#111827",
        color: "#f9fafb",

        width: 640,

        html: `
        <div style="
          margin-top:18px;
          max-height:320px;
          overflow-y:auto;
          padding:16px 18px;
          border-radius:12px;
          background:#0f172a;
          border:1px solid rgba(255,255,255,0.06);
          text-align:left;
          color:#d1d5db;
          font-size:14px;
          line-height:1.8;
        ">
          ${gerarHtmlResumo()}
        </div>
      `,

        icon: "question",

        showCancelButton: true,

        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",

        confirmButtonColor: "#2563eb",
        cancelButtonColor: "#1f2937",

        reverseButtons: true,

        allowOutsideClick: false,
        allowEscapeKey: false,

        customClass: {
          popup: "rounded-4",
          title: "text-lg",
        },

      });

      if (!result.isConfirmed) return;

      // =========================
      // SALVAR
      // =========================

      await api.put(`/usuario/${id}`, payload);

      toast.success("Usuário atualizado com sucesso");

      setTimeout(() => {
        navigate(-1);
      }, 2000);

    } catch (error) {

      console.log(error);

      toast.error("Erro ao atualizar usuário");

    }


    const email = values.email?.trim().toLowerCase() || "";
    // =========================================================
    // VALIDAÇÃO DO E-MAIL
    // =========================================================

    if (email && !emailVerificado) {
      toast.error("Valide o e-mail antes de continuar.");

      setTimeout(() => {
        const elemento = document.querySelector('[name="email"]');

        if (elemento) {
          elemento.focus();
        }
      }, 100);

      return;
    }
  };



 const enviarCodigoEmail = async (emailInformado) => {
  const email = emailInformado?.trim().toLowerCase();

  // ==========================================
  // VALIDA E-MAIL
  // ==========================================

  const emailValido =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
      .test(email);

  if (!email || !emailValido) {
    await Swal.fire({
      html: `
        <div class="swal-email-invalido">

          <div class="swal-email-invalido-icon">
            <i class="bi bi-envelope-exclamation"></i>
          </div>

          <div class="swal-email-invalido-content">

            <div class="swal-email-invalido-title">
              E-mail inválido
            </div>

            <div class="swal-email-invalido-message">
              Insira um e-mail válido para continuar.
            </div>

          </div>

        </div>
      `,

      showConfirmButton: true,
      confirmButtonText: "Entendi",

      customClass: {
        popup: "swal-email-invalido-popup",
        confirmButton: "swal-email-invalido-confirm",
      },

      background: "#0d1b2a",
      color: "#eaf4fb",
      buttonsStyling: false,
    });

    return;
  }

  // ==========================================
  // ENVIA CÓDIGO
  // ==========================================

  try {
    const response = await api.post(
      "/usuarios/enviar-codigo-email",
      {
        email,
      }
    );

    // ==========================================
    // CÓDIGO FOI ENVIADO
    // ==========================================

    if (response.data?.message) {
      setCodigoEnviado(true);

      await abrirModalCodigoEmail(email);
    }

  } catch (error) {
    console.error("Erro ao enviar código:", error);

    // ==========================================
    // ERRO AO ENVIAR
    // ==========================================

    await Swal.fire({
         html: `
    <div class="swal-email-invalido">

      <div class="swal-email-invalido-icon">
        <i class="bi bi-envelope-exclamation"></i>
      </div>

      <div class="swal-email-invalido-content">

        <div class="swal-email-invalido-title">
          E-mail inválido
        </div>

        <div class="swal-email-invalido-message">
          Insira um e-mail válido para continuar.
        </div>

      </div>

    </div>
  `,

      showConfirmButton: true,
      confirmButtonText: "Entendi",

      customClass: {
        popup: "swal-email-invalido-popup",
        confirmButton: "swal-email-invalido-confirm",
      },

      background: "#0d1b2a",
      color: "#eaf4fb",
      buttonsStyling: false,
    });
  }
};



  
  const abrirModalCodigoEmail = async (email) => {
    const result = await Swal.fire({
      title: "Verificar e-mail",

      html: `
        <div class="modal-verificacao-email">
  
          <div class="modal-email-icon">
            ✉
          </div>
  
          <p class="modal-email-text">
            Enviamos um código de 6 dígitos para:
          </p>
  
          <strong class="modal-email-endereco">
            ${email}
          </strong>
  
          <div class="codigo-email-inputs">
  
            <input
              id="codigo-1"
              class="codigo-email-input"
              type="text"
              inputmode="numeric"
              maxlength="1"
              autocomplete="one-time-code"
            />
  
            <input
              id="codigo-2"
              class="codigo-email-input"
              type="text"
              inputmode="numeric"
              maxlength="1"
            />
  
            <input
              id="codigo-3"
              class="codigo-email-input"
              type="text"
              inputmode="numeric"
              maxlength="1"
            />
  
            <input
              id="codigo-4"
              class="codigo-email-input"
              type="text"
              inputmode="numeric"
              maxlength="1"
            />
  
            <input
              id="codigo-5"
              class="codigo-email-input"
              type="text"
              inputmode="numeric"
              maxlength="1"
            />
  
            <input
              id="codigo-6"
              class="codigo-email-input"
              type="text"
              inputmode="numeric"
              maxlength="1"
            />
  
          </div>
  
          <div class="modal-email-expira">
            O código é válido por <strong>15 minutos</strong>.
          </div>
  
        </div>
      `,

      background: "#0f172a",
      color: "#fff",

      showCancelButton: true,

      confirmButtonText: "Validar e-mail",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "#0F73B2",
      cancelButtonColor: "#334155",

      allowOutsideClick: false,

      focusConfirm: false,

      customClass: {
        popup: "modal-verificacao-email-popup",
        confirmButton: "modal-email-confirmar",
        cancelButton: "modal-email-cancelar",
      },

      didOpen: () => {
        const inputs = document.querySelectorAll(
          ".codigo-email-input"
        );

        inputs.forEach((input, index) => {

          input.addEventListener("input", (event) => {

            // Somente números
            event.target.value =
              event.target.value.replace(/\D/g, "");

            if (
              event.target.value &&
              index < inputs.length - 1
            ) {
              inputs[index + 1].focus();
            }
          });

          input.addEventListener("keydown", (event) => {

            if (
              event.key === "Backspace" &&
              !input.value &&
              index > 0
            ) {
              inputs[index - 1].focus();
            }
          });

          input.addEventListener("paste", (event) => {

            event.preventDefault();

            const texto = (
              event.clipboardData ||
              window.clipboardData
            )
              .getData("text")
              .replace(/\D/g, "")
              .slice(0, 6);

            texto.split("").forEach((numero, i) => {
              if (inputs[i]) {
                inputs[i].value = numero;
              }
            });

            const ultimo =
              Math.min(texto.length, 6) - 1;

            if (ultimo >= 0) {
              inputs[ultimo].focus();
            }
          });
        });

        if (inputs[0]) {
          inputs[0].focus();
        }
      },

      preConfirm: async () => {

        const inputs = document.querySelectorAll(
          ".codigo-email-input"
        );

        const codigo = Array.from(inputs)
          .map((input) => input.value)
          .join("");

        if (codigo.length !== 6) {

          Swal.showValidationMessage(
            "Digite o código completo de 6 dígitos."
          );

          return false;
        }

        try {

          const response = await api.post(
            "/usuarios/verificar-codigo-email",
            {
              email,
              codigo,
            }
          );

          return response.data;

        } catch (error) {

          Swal.showValidationMessage(
            error.response?.data?.message ||
            "Código inválido ou expirado."
          );

          return false;
        }
      },
    });

    // ==========================================
    // CÓDIGO CONFIRMADO
    // ==========================================

    if (result.isConfirmed) {

      setEmailVerificado(true);
      setCodigoEnviado(false);

      Swal.fire({
        icon: "success",
        title: "E-mail verificado!",
        text: "O endereço de e-mail foi confirmado com sucesso.",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#0F73B2",
      });
    }
  };


  return (
    <>
      <ToastContainer />

      <div className="usuario-cadastro usuario-edicao">

        <div className="card-usuario">

          {/* =====================================================
            HEADER
        ====================================================== */}
          <div className="usuario-header">

            <div className="usuario-header-left">

              <div className="usuario-header-icon">
                <i className="bi bi-person-gear"></i>
              </div>

              <div>
                <h5 className="usuario-title">
                  Editar usuário
                </h5>

                <span className="usuario-subtitle">
                  Configure o acesso e as permissões do usuário
                </span>
              </div>

            </div>

            <button
              type="button"
              className="usuario-close"
              onClick={() => navigate(-1)}
              title="Fechar"
            >
              <i className="bi bi-x-lg"></i>
            </button>

          </div>


          {/* =====================================================
            CONTEÚDO
        ====================================================== */}
          <div className="cadastro-usuario">

            <form
              autoComplete="off"
              className="usuario-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }}
            >

              {/* =================================================
                DADOS DO USUÁRIO
            ================================================== */}
              <div className="usuario-section">

                <div className="usuario-section-header">

                  <div className="usuario-section-line"></div>

                  <div>
                    <div className="usuario-section-title">
                      Dados do usuário
                    </div>

                    <div className="usuario-section-description">
                      Informações básicas para identificação e acesso
                    </div>
                  </div>

                </div>


                {/* NOME */}
                <div className="usuario-field usuario-field-full">

                  <label className="usuario-label">
                    Nome
                  </label>

                  <input
                    type="text"
                    name="nome"
                    className="usuario-input"
                    value={values.nome || ""}
                    onChange={handleChange}
                    maxLength={65}
                  />

                  <div className="usuario-field-footer">

                    <small className="usuario-counter">
                      {(values.nome || "").length}/65
                    </small>

                  </div>

                </div>


                {/* USUÁRIO + EMAIL */}
                <div className="usuario-grid-2">

                  {/* USUÁRIO */}
                  <div className="usuario-field">

                    <label className="usuario-label">
                      Nome de usuário
                    </label>

                    <input
                      type="text"
                      name="user"
                      className="usuario-input"
                      value={values.user || ""}
                      onChange={handleChange}
                      maxLength={35}
                    />

                    {verificandoUser && (
                      <small style={{ color: "#94a3b8" }}>
                        Verificando disponibilidade...
                      </small>
                    )}

                    {!verificandoUser && userError && (
                      <small style={{ color: "#ef4444" }}>
                        {userError}
                      </small>
                    )}

                    {!verificandoUser && !userError && userDisponivel && (
                      <small style={{ color: "#22c55e" }}>
                        Nome de usuário disponível.
                      </small>
                    )}

                    <div className="usuario-field-footer">

                      <small className="usuario-counter">
                        {(values.user || "").length}/35
                      </small>

                    </div>

                  </div>


                  {/* EMAIL */}
                  <div className="usuario-field">

                    <label className="usuario-label">
                      E-mail
                    </label>

                    <div className="usuario-email-wrapper">

                      <input
                        type="text"
                        name="email"
                        className={`usuario-input ${emailError ? "usuario-input-error" : ""
                          } ${emailDisponivel ? "usuario-input-success" : ""
                          }`}
                        value={values.email || ""}
                        onChange={handleChange}
                        onBlur={(e) => verificarEmail(e.target.value)}
                        maxLength={75}
                      />

                    </div>

                    {/* ==========================================
      E-MAIL COM ERRO
      ========================================== */}

                    {emailError && (
                      <div className="usuario-edicao-email-status">

                        <small className="usuario-edicao-email-error">
                          {emailError}
                        </small>

                      </div>
                    )}

                    {/* ==========================================
      E-MAIL DISPONÍVEL
      ========================================== */}

                    {!emailError &&
                      emailDisponivel &&
                      !emailVerificado && (

                        <div className="email-validacao-area">

                          <div className="email-disponivel">
                            ✓ E-mail disponível
                          </div>

                          <button
                            type="button"
                            className="btn-validar-email"
                            onClick={() => enviarCodigoEmail(values.email)}
                            disabled={verificandoEmail}
                          >
                            ✉ Validar e-mail
                          </button>

                        </div>
                      )}

                    {/* ==========================================
                      E-MAIL JÁ VERIFICADO
                      ========================================== */}

                    {emailVerificado && (
                      <div className="email-verificado">
                        ✓ E-mail verificado
                      </div>
                    )}

                  </div>
                </div>

              </div>


              {/* =================================================
                VEÍCULOS
            ================================================== */}
              <div className="usuario-section">

                <div className="usuario-section-header">

                  <div className="usuario-section-line"></div>

                  <div>
                    <div className="usuario-section-title">
                      Veículos
                    </div>

                    <div className="usuario-section-description">
                      Selecione os veículos que estarão disponíveis para este usuário
                    </div>
                  </div>

                </div>


                {/* BARRA DE PESQUISA */}
                <div className="usuario-selection-toolbar">

                  <div className="usuario-search-wrapper">


                    <input
                      type="text"
                      className="usuario-search"
                      placeholder="Buscar veículo..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />

                  </div>


                  <label className="usuario-check">

                    <input
                      type="checkbox"
                      onChange={(e) => handleAll(e)}
                    />

                    <span className="usuario-check-box"></span>

                    <span className="usuario-check-text">
                      Todos
                    </span>

                  </label>

                </div>


                {/* LISTAS */}
                <div className="usuario-transfer">

                  {/* DISPONÍVEIS */}
                  <div className="usuario-list-box">

                    <div className="usuario-list-header">

                      <span>
                        Disponíveis
                      </span>

                      <span className="usuario-list-count">
                        {filterPlaca.length}
                      </span>

                    </div>

                    <div className="lista-veiculos">

                      {filterPlaca.map((v) => (

                        <div
                          key={v.placa}
                          className="item-veiculo"
                          onClick={() => moverParaSelecionados(v)}
                        >

                          <div className="placa">
                            {v.placa}
                          </div>

                          <div className="descricao">
                            {v.nome}
                          </div>

                        </div>

                      ))}

                    </div>

                  </div>


                  {/* SETA */}
                  <div className="usuario-transfer-arrow">

                    <i className="bi bi-arrow-right"></i>

                  </div>


                  {/* SELECIONADOS */}
                  <div className="usuario-list-box">

                    <div className="usuario-list-header">

                      <span>
                        Selecionados
                      </span>

                      <span className="usuario-list-count">
                        {veiculosSelecionados.length}
                      </span>

                    </div>

                    <div className="lista-veiculos selecionados">

                      {veiculosSelecionados.map((v) => (

                        <div
                          key={v.placa}
                          className="item-veiculo usuario-item-selected"
                          onClick={() => moverParaDisponiveis(v)}
                        >

                          <div className="placa">
                            {v.placa}
                          </div>

                          <div className="descricao">
                            {v.nome}
                          </div>

                        </div>

                      ))}

                    </div>

                  </div>

                </div>

              </div>


              {/* =================================================
                GRUPOS
            ================================================== */}
              <div className="usuario-section">

                <div className="usuario-section-header">

                  <div className="usuario-section-line"></div>

                  <div>
                    <div className="usuario-section-title">
                      Grupos
                    </div>

                    <div className="usuario-section-description">
                      Selecione os grupos que estarão disponíveis para este usuário
                    </div>
                  </div>

                </div>


                {/* BARRA DE PESQUISA */}
                <div className="usuario-selection-toolbar">

                  <div className="usuario-search-wrapper">


                    <input

                      type="text"
                      className="usuario-search"
                      placeholder="Buscar grupo..."
                      value={searchs}
                      onChange={(e) => setSearchs(e.target.value)}
                    />

                  </div>


                  <label className="usuario-check">

                    <input
                      type="checkbox"
                      onChange={(e) => handleAllGrupos(e)}
                    />

                    <span className="usuario-check-box"></span>

                    <span className="usuario-check-text">
                      Todos
                    </span>

                  </label>

                </div>


                {/* LISTAS */}
                <div className="usuario-transfer">

                  {/* DISPONÍVEIS */}
                  <div className="usuario-list-box">

                    <div className="usuario-list-header">

                      <span>
                        Grupos disponíveis
                      </span>

                      <span className="usuario-list-count">
                        {gruposFiltrados.length}
                      </span>

                    </div>

                    <div className="lista-veiculos">

                      {gruposFiltrados.map((grupo) => (

                        <div
                          key={grupo.id}
                          className="item-veiculo"
                          onClick={() =>
                            moverGrupoParaSelecionados(grupo)
                          }
                        >

                          <div className="placa">
                            {grupo.nome}
                          </div>

                        </div>

                      ))}

                    </div>

                  </div>


                  {/* SETA */}
                  <div className="usuario-transfer-arrow">

                    <i className="bi bi-arrow-right"></i>

                  </div>


                  {/* SELECIONADOS */}
                  <div className="usuario-list-box">

                    <div className="usuario-list-header">

                      <span>
                        Selecionados
                      </span>

                      <span className="usuario-list-count">
                        {gruposSelecionadas.length}
                      </span>

                    </div>

                    <div className="lista-veiculos selecionados">

                      {gruposSelecionadas.map((grupo) => (

                        <div
                          key={grupo.id}
                          className="item-veiculo usuario-item-selected"
                          onClick={() =>
                            moverGrupoParaDisponiveis(grupo)
                          }
                        >

                          <div className="placa">
                            {grupo.nome}
                          </div>

                        </div>

                      ))}

                    </div>

                  </div>

                </div>

              </div>


              {/* =================================================
                OBSERVAÇÃO
            ================================================== */}
              <div className="usuario-section usuario-section-observacao">

                <div className="usuario-section-header">

                  <div className="usuario-section-line"></div>

                  <div>
                    <div className="usuario-section-title">
                      Observação
                    </div>

                    <div className="usuario-section-description">
                      Informações adicionais sobre o usuário
                    </div>
                  </div>

                </div>


                <div className="usuario-field">

                  <textarea
                    name="obs"
                    className="usuario-textarea"
                    placeholder="Digite uma observação..."
                    maxLength={500}
                    value={values.obs || ""}
                    onChange={handleChange}
                  />

                  <div className="usuario-textarea-footer">

                    <small>
                      Informações adicionais sobre o usuário
                    </small>

                    <small>
                      {(values.obs || "").length}/500
                    </small>

                  </div>

                </div>

              </div>

            </form>

          </div>


          {/* =====================================================
            FOOTER
        ====================================================== */}
          <div className="usuario-footer">

            <button
              type="button"
              className="btn-cancelar"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-x-lg"></i>
              Cancelar
            </button>


            <button
              type="button"
              className="btn-cadastrar"
              onClick={handleSubmit}
            >
              <i className="bi bi-check2"></i>
              Editar
            </button>

          </div>

        </div>

      </div>
    </>
  );
}
export default UsuarioEdit;
